import './plugins/infodialog.js';
import './utils/jquery.utils';

import DecisionTree from './plugins/decision-tree.js';

import handleAnchorLinks from './plugins/anchor-link.js';
import handleNavBar from './plugins/local-nav.js';
import handleAttentionBanner from './plugins/attention-banner.js';
import handleBodyEvents from './plugins/body-events.js';
import handleEqualHeight from './plugins/equal-height.js';
import handleProcessBar from './plugins/process-bar.js';
import handleNavList from './plugins/nav-list.js';
import handleResponsiveTable from './plugins/responsive-table.js';
import handleStickyFooter from './plugins/sticky-footer.js';

import bootstrapDatepicker from './plugins/date-field/date-field';
import initSelectMenuTypeAhead from './plugins/select2';

import cookieHandler from './plugins/cookie-handler.js';

// application specific
import handleSummeryBar from './plugins/summary-bar.js';
import handleToggleSelect from './plugins/toggle-select.js';

function initCommonFunctionality(customOptions) {
    let defaultOptions = {
        localNavHeaderSelector: '.Hero-box-header, .Section-header'
    };

    let options = jQuery.extend({}, defaultOptions, customOptions);

    if (options.disableInit) {
        return;
    }

    let decisionTree = new DecisionTree();
    decisionTree.init();

    handleNavBar();
    handleAnchorLinks();
    handleAttentionBanner();
    handleBodyEvents();
    handleEqualHeight();
    handleProcessBar();
    handleNavList();
    handleResponsiveTable();
    handleStickyFooter();
    // application specific
    handleSummeryBar();
    handleToggleSelect();
}

export default function (customOptions) {
    initCommonFunctionality(customOptions);

    window.$ = window.jQuery = jQuery;

    // Public API
    window.TD = {
        init: initCommonFunctionality,
        Plugins: {
            ResponsiveTable: {
                init: handleResponsiveTable
            },
            ProcessBar: {
                init: handleProcessBar
            },
            SelectMenuTypeAhead: {
                init: initSelectMenuTypeAhead
            },
            CookieHandler: cookieHandler,
            LocalNav: {
                init: handleNavBar
            },
            datepicker: bootstrapDatepicker
        }
    };
}
